export default __webpack_public_path__ + "static/media/patate.bfa4cd41.jpg";